// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"245":"ecafb7ae","486":"7f6c61e6","698":"5eb504a6"}[chunkId] + ".chunk.css";
};